const initialState =
{
	
};

/**
 * 网站设置
 * @param state 
 * @param action 
 * @returns 
 */
const setting = (state = initialState, action:any) =>
{
	switch (action.type)
	{
		case 'CHANGE_WEBCAM':
		{
			return { ...state, selectedWebcam: action.payload.deviceId };
		}
		default:
			return state;
	}
};

export default setting;
